import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getDistribuciones } from "../../Services/distribucion_service";
import { fetchDistritosAsignados, fetchRegionesAsignadas, fetchSucursalesAsignadas } from "../Delegacion/delegacionSlice";
import { setShowBackdrop } from "../uiSlice";

export const initialStateDistribucion = {
  idDistribucion: -1,
  nombre: "",
  estado: -1,
  codDistribucion: "",
};

const initialState = {
  distribuciones: [],
  distribucion: initialStateDistribucion,
};

export const distribucionSlice = createSlice({
    name: 'distribucion',
    initialState,
    reducers: {
        setDistribuciones: (state, action) => {
            state.distribuciones = action.payload;
        },
        setDistribucion: (state, action) => {
            state.distribucion = action.payload;
        }
    }
});

export const fetchDistribuciones = createAsyncThunk(
    'distribucion/fetchDistribuciones',
    async (data, { dispatch }) => {
        if (data && !data?.noBackdrop)
            dispatch(setShowBackdrop(true));
        const distribucionRes = await getDistribuciones();
        await dispatch(setDistribuciones(distribucionRes));
        if (data && !data.noBackdrop)
            dispatch(setShowBackdrop(false));
    }
);

export const fetchDistribucionItems = createAsyncThunk(
    'distribucion/fetchDistribucionItems',
    async (data, { dispatch }) => {
        switch (data.codDistribucion) {
            case 'distrito':
                await dispatch(fetchDistritosAsignados(data));
                break;
            case 'region':
                await dispatch(fetchRegionesAsignadas(data));
                break;
            case 'sucursal':
                await dispatch(fetchSucursalesAsignadas(data))
                break;
            default:
                break;
        }
    }
);

export const { setDistribuciones, setDistribucion } = distribucionSlice.actions;
export default distribucionSlice.reducer;